@if (error) {
    <small class="color-status-red4">
        An error occurred while loading the documents, please try in some time.
    </small>
} @else {
    <app-table
        noRowsText="No workflow documents to show."
        [attr.data-qa]="dataQa.stationDocumentViewTable"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [masterDetail]="true"
        [suppressMenu]="true"
        [detailCellRendererParams]="detailCellRendererParams"
        [totalItems]="resultCount"
        (gridReady)="onGridReady($event)">
    </app-table>
}
